import moment from 'moment';
import vue from 'vue';
import { find } from 'lodash';

const SET_TIMESLOTS = (state, payload) => {
  // create a timeSlots object with date string as a property name
  // each date property then holds an array of capacity objects for that date
  state.timeSlots = {};

  payload.forEach(date => {
    let dateString = moment(date.startsAt).format('YYYY-MM-DD');
    if (!state.timeSlots[dateString]) { vue.set(state.timeSlots, dateString, []) }
    if (!find(state.timeSlots[dateString], { startsAt: date.startsAt })) {
      state.timeSlots[dateString].push(date);
    }
  })
};

export default {
  SET_TIMESLOTS
};
